import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetBijbEventErrorAction implements Action {
  public static readonly type = 'GetBijbEventErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetBijbEventErrorAction.type;
}
